export default __webpack_public_path__ + "static/bali_2-3d11dfc041b2155bf05d10052fb213c4.png";